import http from "@/axiosConfig";

const oauthRoutes = {
  AZURE_CONFIG_STATUS: "/auth/azure-config",
};

export default {
  // Redirige al usuario al flujo de OAuth de Microsoft
  loginWithMicrosoft() {
    const backendUrl = http.defaults.baseURL || '';
    const fixedUrl = `${backendUrl.replace('/api/', '')}/oauth2/authorization/azure`.replace(/([^:]\/)\/+/g, '$1');
    window.location.href = fixedUrl;
  },

  // Obtiene información del usuario autenticado con OAuth
  checkAzureConfig() {
    return new Promise(resolve => {
      let result = false;
      http.get(oauthRoutes.AZURE_CONFIG_STATUS)
        .then(({ data }) => { result = data })
        .catch((error) => {
          console.error("Error al obtener configuración:", error);
          result = false
        })
        .finally(() => resolve(result));
    });
  },
};
